import Model from "@/lib/model/model";
import request from "../../request/request";

export enum EnumQuestionAppendAskType {
  EnumQuestionAppendAskTypeConst = 1, // 固定追问
  EnumQuestionAppendAskTypeAIGC = 2, // AIGC追问
  EnumQuestionAppendAskTypeSwitch = 3 // 条件追问
}

export enum EnumQuestionAppendConditionType {
  Const = 1, // 100%追问
  Count // 达到字数追问
}

export enum EnumQuestionAppendAIGCAskType {
  GPT = "GPT",
  INFO = "INFO",
  STAR = "STAR",
  FOLLOWUP_BOT_COMMON = "FollowupBotCommon" // 通用
}

export class ReplyCheckpointList extends Model {
  checkpointName = ""; //   `json:"checkpointName"` // 触发条件
  replyTextList: string[] = [""]; // `json:"replyTextList"`  // 追问话术列表
}

// 固定话术
export class ReplyFixedSpeechList extends Model {
  roundNumber = 1;
  replyTextList: string[] = [""];
}

export class RuleAsk extends Model {
  wordLimit = [0, 0]; // []int `json:"wordLimit"`// 题干回答字数
  type = EnumQuestionAppendAskType.EnumQuestionAppendAskTypeAIGC; // 追问话术类型
  aigcType = EnumQuestionAppendAIGCAskType.GPT; // AIGC追问配置类型
  conditionType = EnumQuestionAppendConditionType.Count; // 追问条件
  replyFixedSpeechList: ReplyFixedSpeechList[] = [new ReplyFixedSpeechList()]; // 固定追问-追问话术列表
  replyTextPrefix = ""; //    string `json:"replyTextPrefix"` // AIGC追问-前置追问话术
  replyCheckpointList: ReplyCheckpointList[] = [new ReplyCheckpointList()]; // `json:"replyCheckpointList"` // 条件追问-条件列表
  poppycockReplyTextList = [""];
}
export default class AppendAskConfig extends Model {
  scorePercent = 0; // `json:"scorePercent"` // 得分系数
  askNumber = 0; //int  // 追问次数
  ruleList: RuleAsk[] = [new RuleAsk()]; //   `json:"ruleList"` // 规则列表

  enableAppendAsk = 0; // V1.5中 两种数据结构相互转换使用的临时字段

  //获取追问demo
  static get(questionDesc: string, url = "/aiExam/aiPlus/recommendAppendAsk") {
    return request.post(url, { questionDesc: questionDesc }).then(resp => {
      return resp.data.data.clarificationPrompts;
    });
  }
  //修改题目追问配置 data:{questionId 题目id;isAppendAsk 是否追问;appendAskConfig 追问配置}
  static updateAppendAsk(
    data: any,
    url = "/aiExam/question2/updateAppendAskConfig"
  ) {
    return request.post(url, data).then(resp => {
      // console.log("updateAppendAskConfig", resp);
    });
  }
}
